export default __webpack_public_path__ + "locales/sk/ChangeEmailDialog.json?hash=5be9dbc6fc50ef4a59cecb06a7300b2b";